import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { ModalPortal } from '../../../../../components/modal-portal';
import style from './delete-modal.module.css';
import { messages } from './messages';

const DeleteModal = ({ onClose, onDelete, packageName }) => {
  const [isDeleting, setIsDeleting] = useAsyncSafeState(false);

  const handleOnDelete = () => {
    setIsDeleting(true);
    onDelete();
  };

  return (
    <ModalPortal containerId='custom-packages-delete-modal' onClose={onClose}>
      <Modal size='small'>
        <ModalHeader>
          <FormattedMessage {...messages.title} values={{ packageName }} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <FormattedMessage {...messages.description} values={{ packageName }} />
        </ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton />
          <Button disabled={isDeleting} onClick={handleOnDelete} theme='danger'>
            {isDeleting ? <FormattedMessage {...messages['deleting-button']} /> : <FormattedMessage {...messages['delete-button']} />}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

DeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  packageName: PropTypes.string.isRequired,
};

export default DeleteModal;
